/**
 * Verifica se a aula foi realizada em uma determinada data.
 * - Modo AULA: TODAS as aulas do dia precisam estar com `realizada` true.
 * - Modo DIA: baseado em aulasRealizadasDias (endpoint aula-realizada/dia)
 */
export function aulaFoiRealizada(
  data: string,
  tipoTelaFrequencia: 'dia' | 'aula' | null,
  aulasCabecalhoAula: any[],
  aulasRealizadasDias: any[]
): boolean {
  if (tipoTelaFrequencia === 'aula') {
    if (!aulasCabecalhoAula || aulasCabecalhoAula.length === 0) {
      return false;
    }

    const diaEncontrado = aulasCabecalhoAula.find(dia => dia.data === data);
    if (!diaEncontrado || !diaEncontrado.aulas) {
      return false;
    }

    return diaEncontrado.aulas.every((aula: any) => aula.realizada === true);
  }

  if (!aulasRealizadasDias || aulasRealizadasDias.length === 0) {
    return false;
  }
  return aulasRealizadasDias.some((aula: any) => aula.data === data);
}

/**
 * Monta o payload de aulas do dia, usado tanto para marcar (realizada: true)
 * quanto para desmarcar (realizada: false) presença em lote.
 */
export function montarPayloadAulasRealizadas(
  aulasDoDia: any[],
  dataSelecionada: string,
  realizada: boolean,
  isTurmaAtividade: boolean,
  isEjaModular: boolean,
  turmaId: number,
  periodoAvaliativoId: number
): any[] {
  return aulasDoDia.map(aula => {
    const payload: any = {
      numero: aula.numero,
      data: dataSelecionada,
      inicioAula: aula.inicioAula,
      fimAula: aula.fimAula,
      realizada,
      itemEducacional: {
        id: aula.idItemEducacional,
        descricao: aula.descricaoItemEducacional
      },
      turma: { id: turmaId },
      periodoAvaliativo: { id: periodoAvaliativoId }
    };

    if (aula.id) {
      payload.id = aula.id;
    }

    // EJA Modular e Turma Atividade não usam periodoAvaliativo
    if (isEjaModular || isTurmaAtividade) {
      delete payload.periodoAvaliativo;
    }

    return payload;
  });
}
